// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle_Toggle___YU_l","label-first":"Toggle_label-first__Y_meK","Toggle-small":"Toggle_Toggle-small__L9qYQ"};